var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { loadCssDesign } from '../utils/Utils';
import { TRANSLATIONS } from './tanslate';
var Search = function (_a) {
    var Select = _a.Select, Option = _a.Option, Button = _a.Button, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, requestGet = _a.requestGet, RESPONSE = _a.RESPONSE, history = _a.history, projectId = _a.projectId, CONSTANTS_REQ = _a.CONSTANTS_REQ, _b = _a.projectType, projectType = _b === void 0 ? 'kiosk' : _b, _c = _a.defaultSelectTypeValue, defaultSelectTypeValue = _c === void 0 ? '' : _c, _d = _a.defaultSelectLocationValue, defaultSelectLocationValue = _d === void 0 ? '' : _d, css_id = _a.css_id, css_json = _a.css_json, _e = _a.saveCss, saveCss = _e === void 0 ? true : _e, snapShot = _a.snapShot;
    var selLang = getSelectedClientLanguage();
    var _f = useState([]), searchTypeTop = _f[0], setSearchTypeTop = _f[1];
    var _g = useState([]), locations = _g[0], setLocations = _g[1];
    var _h = useState(undefined), searchTypeSelected = _h[0], setSearchTypeSelected = _h[1];
    var _j = useState(undefined), locationSelected = _j[0], setLocationSelected = _j[1];
    var searchType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestGet(CONSTANTS_REQ.CLIENT.SEARCH_CONTENT_TYPE + '/0')];
                case 1:
                    resp = _a.sent();
                    if (resp.status === RESPONSE.OK) {
                        if (Object.keys(resp.data).length > 0) {
                            setSearchTypeTop(resp.data);
                            resp.data.forEach(function (item) {
                                if (item.id == defaultSelectTypeValue) {
                                    setSearchTypeSelected(item.id);
                                }
                            });
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var locationList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(projectId == undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.LOCATION_LIST_SNAPSHOT : CONSTANTS_REQ.CLIENT.LOCATION_LIST, {
                            max: 100,
                            active: true,
                            order: 'name',
                            orderType: 'asc',
                        })];
                case 1:
                    resp = _a.sent();
                    if (resp.status === RESPONSE.OK) {
                        if (Object.keys(resp.data).length > 0) {
                            setLocations(resp.data.content);
                            resp.data.content.forEach(function (item) {
                                if (item.id == defaultSelectLocationValue) {
                                    setLocationSelected(item.id);
                                }
                            });
                        }
                    }
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, requestGet(snapShot && snapShot === true ? CONSTANTS_REQ.CLIENT.LOCATION_LIST_PROJECTS_SNAPSHOT : CONSTANTS_REQ.CLIENT.LOCATION_LIST_PROJECTS, {
                        max: 100,
                        active: true,
                        projectId: projectId,
                        order: 'name',
                        orderType: 'asc',
                    })];
                case 3:
                    resp = _a.sent();
                    if (resp.status === RESPONSE.OK) {
                        if (Object.keys(resp.data).length > 0) {
                            setLocations(resp.data.content);
                            resp.data.content.forEach(function (item) {
                                if (item.id == defaultSelectLocationValue) {
                                    setLocationSelected(item.id);
                                }
                            });
                        }
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        searchType();
        locationList();
        loadCssDesign(css_id, css_json, CONSTANTS_REQ);
    }, []);
    var onClickButton = function (e) {
        e.preventDefault();
        if (saveCss == true) {
            localStorage.setItem('search_result_css_json', css_json);
        }
        if (projectType === 'kiosk') {
            history.push({
                pathname: "/" + projectId + "/search-results/" + searchTypeSelected + "/" + locationSelected,
                state: { css: css_json },
            });
        }
        else if (projectType === 'prime') {
            history.push("/search-results/" + searchTypeSelected + "/" + locationSelected);
        }
        else {
            history.push("/" + getSelectedClientLanguage() + "/search-results/" + searchTypeSelected + "/" + locationSelected);
        }
    };
    return (React.createElement("div", { id: css_id },
        React.createElement("div", { className: "row module-search", style: { marginLeft: '0px', marginRight: '0px', marginBottom: '0px' } },
            React.createElement("div", { className: "col-xs-5 col-sm-4 col-md-3 col-lg-3", style: { paddingLeft: '0px', paddingRight: '0px' } },
                React.createElement("div", { style: { marginBottom: '25px' } },
                    React.createElement("div", { className: "module-search-label-for" }, TRANSLATIONS[selLang]['label.searchFor']),
                    React.createElement(Select, { showSearch: true, placeholder: TRANSLATIONS[selLang]['label.selectType'], optionFilterProp: "children", style: { width: '100%' }, size: "default", onSelect: function (e) { return setSearchTypeSelected(e); }, value: searchTypeSelected }, searchTypeTop != null &&
                        searchTypeTop.map(function (item) {
                            return (React.createElement(Option, { key: item.id, value: item.id }, getTranslated(item.name, selLang)));
                        })))),
            React.createElement("div", { className: "col-xs-2 col-sm-2 col-md-1 col-lg-1" },
                React.createElement("div", { className: "module-search-label-in" },
                    React.createElement("span", null, TRANSLATIONS[selLang]['label.in']))),
            React.createElement("div", { className: "col-xs-5 col-sm-4 col-md-3 col-lg-3", style: { paddingLeft: '0px', paddingRight: '0px' } },
                React.createElement("div", { style: { marginBottom: '25px' } },
                    React.createElement("div", { className: "module-search-label-for" }, TRANSLATIONS[selLang]['label.location']),
                    React.createElement(Select, { showSearch: true, placeholder: TRANSLATIONS[selLang]['label.selectLocation'], optionFilterProp: "children", style: { width: '100%' }, size: "default", onSelect: function (e) { return setLocationSelected(e); }, value: locationSelected }, locations != null &&
                        locations.map(function (item) {
                            return React.createElement(Option, { value: item.id }, item.name);
                        })))),
            React.createElement("div", { className: "col-xs-12 col-sm-2 col-md-1 col-lg-1", style: { textAlign: 'center', alignSelf: 'flex-end' } },
                React.createElement("div", { style: { marginTop: '26px', marginBottom: '25px' } },
                    React.createElement(Button, { size: "default", htmlType: "submit", onClick: onClickButton, disabled: searchTypeSelected == null }, TRANSLATIONS[selLang]['label.button']))))));
};
export default Search;
//# sourceMappingURL=index.js.map